import { useAppDispatch, useAppSelector } from '@/app/hooks'
import { Spinner } from '@/components/atoms/Spinner'
import { SearchInput } from '@/components/molecules/SearchInput'
import { TrackItem } from '@/components/molecules/TrackItem'
import {
  selectSearchResults,
  setIsWriting
} from '@/features/search/searchSlice'
import { SelectAuth } from '@/features/spotifyAuth/authSlice'
import { useEffect } from 'react'
import './search.scss'

export const Search = () => {
  const dispatch = useAppDispatch()
  const { searchResults, status } = useAppSelector(selectSearchResults)
  const { isGuest } = useAppSelector(SelectAuth)

  useEffect(() => {
    return () => {
      // dispatch(setSearchResults({ items: [] }))
      dispatch(setIsWriting(false))
    }
  }, [dispatch])

  return (
    <main className='p-search'>
      <SearchInput isGuest={isGuest} />
      <div className='p-search__results'>
        {status.searchState === 'loading' ? (
          <Spinner />
        ) : (
          <TrackItem tracks={searchResults} />
        )}
      </div>
    </main>
  )
}
